<template>
  <div class="dg__copyright text-center t-[12]">
    <p class="t-[#B7B9BE]"><span class="pb-[4] t-[12] border-b-[1] border-[#D5DAE5] border-solid">
        <span class="aui-middle">{{conf.statement || '声明：本平台仅提供技术支持，所有保函产品均由保函下发金融机构提供，销售、理赔等服务均由本平台合作的金融机构提供'}}</span>
      </span></p>
    <div class="">
      <p class="t-[#888A90] mx-[auto] pb-[4] pt-[8] leading-[20] t-[12]" :class="copyrightWidth">
        <span v-if="!$route.query.appid && $route.query.taction != 'CustomsInsure'">{{ conf.organizer }}</span>

        <span class="t-[#909399] t-[12]" style="white-space:nowrap">
          <img v-if="getAssetsFile('gov.png')" width="16" :src="getAssetsFile('gov.png')" class="ml-[6] mb-[4]" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="!t-[theme]">{{ conf.beiAn }}</a>
        </span>
      </p>
    </div>

  </div>
</template>
<script>
import mixin from '@/assets/js/mixin.js'
export default {
  mixins: [mixin],
  name: 'dg-copyright',
  props: {
    copyrightWidth: {
      type: String,
      default: "w-[1024]",
    },
    positionType: {
      type: String,
      default: "absolute",
    },
    setStyle: {
      type: Object,
      default: () => {
        return {
          paddingTop: '16px',
          paddingBottom: '16px',
        }

      }
    },
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {
 
   },
  created() { },
}
</script>
<style scoped lang="less"></style>
